<template>
  <div class="hiq-article-list__date-filter hiq-article-list__filter hiq-search-filter">
    <label for="datepicker-trigger" class="hiq-article-list__date-filter-label hiq-search-filter__label">
      Publiceringsdatum
    </label>
     <button
      class="hiq-search-filter__btn date-filter"
      type="button"
      @click="toggleShowDatepicker()"
      data-toggle="hiq-article-list__date-filter-content"
      data-close-outside
      id="datepicker-trigger">
      <span
        class="hiq-article-list__tag-filter-btn__text hiq-search-filter__btn-text">
        Välj datum
      </span>
    </button>
    <div
      class="hiq-article-list__date-filter-content"
      id="hiq-article-list__date-filter-content">
      <v-date-picker
        v-model="range"
        mode="date"
        is-range
        :model-config="modelConfig"
         @input="onDateRangeChange">
      </v-date-picker>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { search } from '../store/actions';

import VDatePicker from "v-calendar";
Vue.use(VDatePicker);

import moment from 'moment';
let locale = document.documentElement.lang;
moment.locale(locale);

interface DatePickerFilterData {
  showDatepicker: boolean,
  range: any,
  modelConfig: {};
  popover: {};
}

interface DatePickerFilterComputed {
  start: string,
  end: string
}

interface DatePickerFilterMethods {
  getRange(): any,
  onDateRangeChange(): void;
  getFormatedDate(): any;
  clearDate(): void;
  toggleShowDatepicker(): void
}

export default Vue.extend<DatePickerFilterData, DatePickerFilterMethods, DatePickerFilterComputed, {}>({
  name: "DatePickerFilter",
  data() {
    return {
      showDatepicker: false,
      range: (this as unknown as DatePickerFilterMethods).getRange(),
      modelConfig: {
        start: {
          type: 'number',
          mask: 'YYYYMMDD',
        },
        end: {
          type: 'number',
          mask: 'YYYYMMDD',
        }
      },
      popover: {
        visibility: "hidden",
        showDelay: 0,
        transition: "none",
      },
    }
  },

  computed: {
    start() {
      return this.$store.getters.start;
    },
    end() {
      return this.$store.getters.end;
    }
  },


  methods: {
    toggleShowDatepicker() {
      this.showDatepicker = !this.showDatepicker;
    },
    getRange() {
      if(this.$store.getters.start && this.$store.getters.end) {
        return {
          start: this.$store.getters.start,
          end: this.$store.getters.end
        }
      }
      return null;
    },
    onDateRangeChange() {
      let startDateString = '';
      let endDateString = '';
      if(this.range) {
        if(this.range.start) {
          startDateString = moment(this.range.start).format('YYYYMMDD');
        }
        if(this.range.end) {
          endDateString = moment(this.range.end).format('YYYYMMDD');
        }
      }

      this.$store.commit({
        type: 'setDates',
        payload: {
          start: startDateString,
          end: endDateString
        }
      })

      this.$store.dispatch(search(''));
    },
    getFormatedDate() {
      if(this.range) {
        return moment(this.range.start).format('YYYY-MM-DD')
        + ' - ' + moment(this.range.end).format('YYYY-MM-DD');
      } else {
        return '';
      }
    },
    clearDate() {
      this.range = null;
      this.onDateRangeChange();
    }
  },

  watch: {
    start() {
      if(this.start == '' || !this.start) {
        this.range = null;
      }
    }
  }
});
</script>
